/* Shared native Sami Jewels footer. Original approved consent/list/payload preserved. */
(function () {
  'use strict';
  if (window.__sjSharedFooter1793304757) return;
  window.__sjSharedFooter1793304757 = true;
  function headerOffset() {
    var h = document.querySelector('.section-header');
    var r = h ? h.getBoundingClientRect() : null;
    return (r && r.height < 260 ? r.height : 90) + 16;
  }
  function scrollToId(id) {
    var el = document.getElementById(id); if (!el) return false;
    var top = el.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    var input = el.querySelector('input[type=email]');
    if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, 600);
    return true;
  }


function bindSignup(ea) {
    if (!ea || ea.dataset.sjFooterBound) return;
    ea.dataset.sjFooterBound = '1793304757';
    var form = ea.querySelector('form'), note = ea.querySelector('.sjhh-ea__note'), done = ea.querySelector('.sjhh-ea__done');
    var btn = form.querySelector('button[type=submit]'), input = form.querySelector('input[type=email]'), label = btn.textContent;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.elements.company_website && form.elements.company_website.value) return;
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        input.setAttribute('aria-invalid', 'true'); note.textContent = 'Please enter a valid email address.'; note.classList.add('is-error'); input.focus(); return;
      }
      input.removeAttribute('aria-invalid'); note.classList.remove('is-error'); note.textContent = note.getAttribute('data-default') || '';
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Black Friday homepage footer', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: form.dataset.list } } } } };
      btn.disabled = true; btn.textContent = 'Joining…';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (r.status < 200 || r.status >= 300) throw new Error('status ' + r.status);
          form.hidden = true; done.hidden = false; try { done.focus({ preventScroll: true }); } catch (e) {}
          try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
          try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'bf_early_access_signup', location: 'homepage_footer' }); } catch (e) {}
        })
        .catch(function () { note.textContent = 'Something went wrong. Please try again.'; note.classList.add('is-error'); })
        .finally(function () { btn.disabled = false; btn.textContent = label; });
    });
  }
  function boot() {
    document.querySelectorAll('[data-sj-sitewide-signup]').forEach(bindSignup);
    /* Anchor scroll (announcement bar lives outside root after move) */
    document.querySelectorAll('[data-sjhh-scroll]').forEach(function (a) {
      if (a.dataset.sjhhBound) return; a.dataset.sjhhBound = '1';
      a.addEventListener('click', function (e) { if (scrollToId(a.getAttribute('data-sjhh-scroll'))) e.preventDefault(); });
    });


    if (window.location.hash === '#early-access') scrollToId('early-access');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
